import React from 'react';

class Quote extends React.PureComponent {
  render() {
    return (
      <div className="quote-container">
        <h2 className="quote">
          Mathematics is not about a numbers, equations, computations,or
          algorithms: it is about understanding. - Williams Paul Thurston
        </h2>
      </div>
    );
  }
}
export default Quote;
